// Modal Dialog Component

if (!customElements.get('modal-dialog')) {
  class ModalDialog extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('keyup', (event) => {
        if (event.code && event.code.toUpperCase() === 'ESCAPE') this.hide();
      });

      const closeButton = this.querySelector('[id^="ModalClose-"]');
      if (closeButton) {
        closeButton.addEventListener('click', this.hide.bind(this));
      }

      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }

    connectedCallback() {
      if (this.moved) return;
      this.moved = true;
      document.body.appendChild(this);
    }

    show(opener) {
      this.openedBy = opener;
      document.body.classList.add('overflow-hidden');
      this.setAttribute('open', '');
    }

    hide() {
      document.body.classList.remove('overflow-hidden');
      this.removeAttribute('open');
      if (this.openedBy && typeof this.openedBy.focus === 'function') {
        this.openedBy.focus();
      }
    }
  }

  customElements.define('modal-dialog', ModalDialog);
  window.ModalDialog = ModalDialog;
} else if (!window.ModalDialog) {
  window.ModalDialog = customElements.get('modal-dialog');
}
